import React from "react";
import { get, post, deleteRequest } from "../../../../shared/data";

export const getFrontShot = (wipKey) => {
    return get(`/photography/wips/${wipKey}/shots?isActive=true`).then((shots) => {
        const frontView = shots.find((shot) => shot.imageView === "SM 1");

        return frontView ? frontView : null;
    });
};

export const getPegholes = (wipKey, shotKey) => {
    return get(`/coding/pegholes/${wipKey}/shots/${shotKey}`)
        .then((response) => {
            return response.items;
        })
        .catch(() => {
            return [];
        });
};

// TODO: this seems to be used in attributes, how should we pass 'sourcePage'???
export const savePegholes = (wipKey, shotKey, payload, sourcePage) => {
    return post(`/coding/pegholes/${wipKey}/shots/${shotKey}?sourcePage=${sourcePage}`, {
        items: payload,
    });
};

export const deletePeghole = (wipKey, shotKey) => {
    return deleteRequest(`/coding/pegholes/${wipKey}/shots/${shotKey}`);
};

export const displayMeasurements = (measurements) => {
    return measurements.map((p, i) => {
        const text = Object.keys(p.Measurements).map((m) => {
            return (
                <div key={`${i}_${m}`}>
                    {m}: {p.Measurements[m]}
                </div>
            );
        });

        return (
            <div key={`measurement_${i}`} className="selected-item">
                <h4>
                    {pegDescriptionMap[p.TypeCode]} ({p.TypeCode})
                </h4>
                {text}
            </div>
        );
    });
};

export const pegHoleTypes = [
    {
        value: "ES1",
        text: "Euro Slot 25mm",
    },
    {
        value: "ES2",
        text: "Euro Slot 33mm",
    },
    {
        value: "HH1",
        text: "Hole Hook",
    },
    {
        value: "RL1",
        text: "Round hole",
    },
    {
        value: "SL1",
        text: "Slot hole 10mm",
    },
    {
        value: "SL3",
        text: "Slot hole 7mm",
    },
];

export const pegDescriptionMap = pegHoleTypes.reduce((obj, type) => {
    obj[type.value] = type.text;

    return obj;
}, {});
